'use strict'

class CookieHelper {
    static getClientId(cookie) {
        return cookie.get('C-Smartix-Client-Id')
    }

    static setClientId(cookie, id) {
        cookie.set('C-Smartix-Client-Id', id, 1)
    }

    static delClientId(cookie) {
        cookie.delete('C-Smartix-Client-Id')
    }
}

export default CookieHelper
